import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, X } from './Icons.jsx';

const SESSION_KEY = 'mm-urgency-dismissed';

// Next Career Camp London cohort — update these values when the cohort changes.
const NEXT_COHORT = { city: 'London', dates: 'Jul 14–18', spotsLeft: 4, capacity: 12 };

export default function UrgencyBar() {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(SESSION_KEY) === '1');
  const loc = useLocation();

  // Don't show on drill / immersive routes
  const hidden = loc.pathname.startsWith('/drill') || loc.pathname.startsWith('/tutor-portal') || loc.pathname === '/parents';

  if (dismissed || hidden) return null;

  const dismiss = () => { sessionStorage.setItem(SESSION_KEY, '1'); setDismissed(true); };

  return (
    <div style={bar}>
      <div style={inner}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
          <span style={dot}>●</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            Next London Career Camp · {NEXT_COHORT.dates} · {NEXT_COHORT.spotsLeft} of {NEXT_COHORT.capacity} spots left
          </span>
        </div>
        <Link to="/career-camp" style={cta}>
          See cohort <ArrowRight width="13" height="13" />
        </Link>
        <button onClick={dismiss} aria-label="Dismiss" style={closeBtn}><X width="14" height="14" /></button>
      </div>
    </div>
  );
}

const bar = {
  background: 'linear-gradient(135deg, var(--feature-from), var(--feature-via), var(--feature-to))',
  color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.1)',
  position: 'relative', zIndex: 5
};
const inner = {
  maxWidth: 1300, margin: '0 auto',
  display: 'flex', alignItems: 'center', gap: 12,
  padding: '8px 16px'
};
const dot = {
  display: 'inline-block', color: '#fbbf24', fontSize: 14,
  animation: 'mm-pulse-dot 1.6s ease-in-out infinite'
};
const cta = {
  background: '#fff', color: 'var(--brand-deep)',
  padding: '5px 10px', borderRadius: 6, fontSize: 12.5, fontWeight: 700,
  textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4,
  flexShrink: 0, whiteSpace: 'nowrap'
};
const closeBtn = {
  background: 'transparent', border: 'none', cursor: 'pointer',
  color: 'rgba(255,255,255,0.7)', padding: 4, display: 'grid', placeItems: 'center',
  flexShrink: 0
};
